const DotAnimation = ({direction})=>{
    return(
        <div className={`
            relative
            scroll-dot-wrap
            [&>.scroll-dot]:w-[4px]
            [&>.scroll-dot]:h-[4px]
            [&>.scroll-dot]:rounded-[50%]
            [&>.scroll-dot]:bg-red1
            flex flex-${direction} gap-[8px]
            items-center
        `}>
            <div className="scroll-dot dot-1"></div>
            <div className="scroll-dot dot-2"></div>
            <div className="scroll-dot dot-3"></div>
        </div>
    )
}

export default DotAnimation;